///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.vendor_name_change = abcsetup.vendor_name_change || {};
abcsetup.vendor_name_change.common = abcsetup.vendor_name_change.common || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.vendor_name_change.common = {
}